import {
  getAllRolesService,
  queryRolesService,
} from '../services/contentService';
import { compareLocal, sortBy } from '../utils/helpers';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getAllRoles = createAsyncThunk('roles/getAllRoles', async () => {
  const response = await getAllRolesService();
  return response.data;
});

export const queryRoles = createAsyncThunk(
  'roles/queryRoles',
  async (roleID) => {
    const response = await queryRolesService(roleID);
    return response.data;
  }
);

// slice
const rolesSlice = createSlice({
  name: 'roles',
  initialState: {},
  reducers: {
    removeRole(state, action) {
      const idToRemove = action.payload;
      if (state[idToRemove]) {
        const { [idToRemove]: value, ...withoutRole } = state;
        return withoutRole;
      }
      return state;
    },
    updateRoleAreasOrder(state, action) {
      const { id, areasOrder, additionalAreasOrder } = action.payload;
      if (state[id]) {
        state[id].areas = areasOrder;
        state[id].additionalAreas = additionalAreasOrder;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllRoles.pending, (state) => {
        console.log('Fetching all roles...');
        return state;
      })
      .addCase(getAllRoles.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(getAllRoles.rejected, (action) => {
        console.error('Failed to fetch roles:', action.error);
      })
      .addCase(queryRoles.pending, (state) => {
        console.log('Querying roles...');
      })
      .addCase(queryRoles.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(queryRoles.rejected, (action) => {
        console.error('Failed to query roles:', action.error);
      });
  },
});

export default rolesSlice.reducer;
export const rolesActions = rolesSlice.actions;
export const { removeRole, updateRoleAreasOrder } = rolesSlice.actions;
export const REMOVE_ROLE = 'roles/removeRole';

// Selectors
export const selectRolesSortOrder = (state) =>
  sortBy(Object.keys(state.roles), [
    (a, b) => compareLocal(state.roles[a].name, state.roles[b].name),
  ]);
